"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var ReadOnlyMessage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ReadOnlyMessage, _PureComponent);

  function ReadOnlyMessage() {
    (0, _classCallCheck2.default)(this, ReadOnlyMessage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReadOnlyMessage).apply(this, arguments));
  }

  (0, _createClass2.default)(ReadOnlyMessage, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation.save." + suffix;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UITooltip.default, {
        placement: "bottom",
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "readOnly"
        })
      }, _react.default.createElement("span", null, _react.default.createElement(_UIIcon.default, {
        name: "block",
        className: "m-right-2"
      }), _react.default.createElement("span", {
        className: "secondary-navigation-saving__info-text"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('errorMessage.readOnly')
      }))));
    }
  }]);
  return ReadOnlyMessage;
}(_react.PureComponent);

exports.default = ReadOnlyMessage;
module.exports = exports.default;